import { makeAutoObservable } from "mobx";
import { Subject } from "rxjs"; 
import {
  IAPIPaginationResponse,
  PaginationModel,
} from "@mindmemobile/mm-shared-global";
import { SubscriptionGridModel } from "../models/SubscriptionGridModel";
import { SubscriptionDetailPageModel } from "../models/SubscriptionModels";
import { IAPISubscriptionGridModel } from "../interfaces/IAPISubscriptionModels";

export default class SubscriptionStore {
  public gridData: SubscriptionGridModel[] = [];
  public pagination: PaginationModel = new PaginationModel({ pageSize: 10 });
  public searchSubject = new Subject<boolean>();
  public searchValue: string = '';
  public detailPage: SubscriptionDetailPageModel | null = null;
  public showFilter: boolean = false;
  constructor() {
      makeAutoObservable(this);
  }

  toggleFilter(): void {
      this.showFilter = !this.showFilter;
  }

  updateDetailPage(data: SubscriptionDetailPageModel): void {
      this.detailPage = new SubscriptionDetailPageModel(data);
  }

  updateSearchValue(value: string): void {
      this.searchValue = value;
      this.pagination = new PaginationModel({ pageNumber: 1, pageSize: 10 });
      this.searchSubject.next(true);
  }

  deserializeGridData(
      data: IAPISubscriptionGridModel[],
      pagination: IAPIPaginationResponse,
      exceptPagination: boolean = false,
  ): void {
      const mappedData = data.map((item) => SubscriptionGridModel.deserializeAPIModel(item));
      this.gridData = mappedData;
      if (exceptPagination) {
          return;
      }
      this.pagination = PaginationModel.deserialize(pagination);
  }

  updatePagination(data: PaginationModel): void {
      this.pagination = new PaginationModel(data);
  }
}
